import { createContext, useContext } from "react";

export const DashboardLayoutContext = createContext({
    closeMobileNav: () => {},
    desktopNavOpen: true,
    toggleDesktopNav: () => {},
    navCollapsed: false,
});

export function useCloseMobileNav() {
    return useContext(DashboardLayoutContext).closeMobileNav;
}

export function useDesktopNavOpen() {
    return useContext(DashboardLayoutContext).desktopNavOpen;
}

export function useToggleDesktopNav() {
    return useContext(DashboardLayoutContext).toggleDesktopNav;
}

/** True when the permanent sidebar is collapsed to icons only (desktop). */
export function useNavCollapsed() {
    return useContext(DashboardLayoutContext).navCollapsed;
}
